import { render, staticRenderFns } from "./TeamCalendarEventPopup.vue?vue&type=template&id=44c15ce2&"
import script from "./TeamCalendarEventPopup.vue?vue&type=script&lang=js&"
export * from "./TeamCalendarEventPopup.vue?vue&type=script&lang=js&"
import style0 from "./TeamCalendarEventPopup.vue?vue&type=style&index=0&id=44c15ce2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VCard,VIcon,VMenu})
